'use client'

import { STATES_BY_SLUG } from '@/lib/generated/states'
import { getCountryFromRegion } from '@shared/formats/state'
import { FilterChipSelect, FilterChipRange } from './filter-chip'
import { useListingBrowseContext } from '../context/listing-browse-context'
import { useFieldConfig } from '@/components/specs/hooks/use-field-config'

export const ALL_PRODUCTS_CONDITION_OPTIONS = [{ label: 'New', value: 'new' }] as const

export function ConditionFilter() {
 const { conditions, setConditions, productType } = useListingBrowseContext()
 const { getConditionOptions } = useFieldConfig(productType || '')

 const conditionOptions =
  productType === null ? ALL_PRODUCTS_CONDITION_OPTIONS : getConditionOptions()

 if (conditionOptions.length === 0) return null

 return (
  <FilterChipSelect
   label="Condition"
   options={[...conditionOptions]}
   value={conditions}
   onChange={setConditions}
   multiple
  />
 )
}

export function PriceFilter() {
 const { priceRange, setPriceRange, intentFilter } = useListingBrowseContext()

 if (intentFilter === 'recycle') return null

 return (
  <FilterChipRange
   label="Price"
   min={priceRange.min}
   max={priceRange.max}
   onChange={(min, max) => setPriceRange({ min, max })}
   prefix="$"
  />
 )
}

export const STATE_OPTIONS = Object.values(STATES_BY_SLUG)
 .filter((state) => getCountryFromRegion(state.code) === 'US')
 .map((state) => ({ label: state.name, value: state.code }))
 .sort((left, right) => left.label.localeCompare(right.label))

export const LISTED_AFTER_OPTIONS = [
 { label: '24 hours', shortLabel: '24 h', value: '1' },
 { label: '7 days', shortLabel: '7 d', value: '7' },
 { label: '30 days', shortLabel: '30 d', value: '30' },
 { label: '90 days', shortLabel: '90 d', value: '90' },
] as const
